import { render, staticRenderFns } from "./ModalCampaignSchedule.vue?vue&type=template&id=10ff4c6a&scoped=true&"
import script from "./ModalCampaignSchedule.vue?vue&type=script&lang=js&"
export * from "./ModalCampaignSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff4c6a",
  null
  
)

export default component.exports